<div class="d-flex flex-column wishlist-container">
  <div class="d-flex justify-content-between align-items-center">
    @if(data.state && data.district){ @if( data.type==='pm' ||
    data.type==='centralizedPm'){
    <span class="wishlist-text">Wishlists of &nbsp;{{ data.state }}, &nbsp;{{ data.district }}
      {{ queryParams["pincode"] ? " - " + queryParams["pincode"] : "" }}</span>
    <!-- }@else {
    <span class="wishlist-text">Wishlists of {{ data.state }},{{ data.district }}
    </span> -->
    } }@else{
    <span class="wishlist-text"> Wishlists </span>
    }
    <div class="img-container" (click)="onClose()">
      <img src="../../../assets/images/crossIconDarkTheme.svg" class="cross-icon" />
    </div>
  </div>
  <div class="filter">
    <div class="d-flex flex-column input-div">
      <span class="input-text">Enter wishlist name</span>
      <!-- @if(!data.pincode && data.type === 'centralizedPm'){
      <div style="position: relative;">
        <input class="dp-input-control wishlist-input" [formControl]="searchName"
          placeholder="Search by wishlist name" />
        <div class="pos-div new-div" style="background: var(--search); " (click)="onWishlistName()">
        </div>
      </div>

      }@else{ -->
      <input class="dp-input-control wishlist-input" [(ngModel)]="searchTerm" (ngModelChange)="onSearch($event)"
        placeholder="Search by wishlist name" />
      <!-- } -->
    </div>
    @if(data.type === 'centralizedPm'){
    <div class="d-flex flex-column input-div">
      <span class="input-text">Enter Serial No.</span>
      <div style="position: relative;">
        <input class="dp-input-control wishlist-input" [formControl]="memKey" placeholder="Search by sl no." />
        <div class="pos-div new-div" style="background: var(--search); " (click)="OnMemKeySearch()">
        </div>
      </div>
    </div>
    }
    @if(data.type == 'centralizedPm' && !queryParams['pincode']){
    <div class="d-flex flex-column input-div">
      <span class="input-text">Enter Pincode</span>
      <input class="wishlist-input dp-input-control" type="tel" placeholder="Enter Pincode" aria-label="Search"
        [formControl]="pin" [matAutocomplete]="autopin" maxlength="6" (click)="fetchDistrictPincode()" />

      <mat-autocomplete autoActiveFirstOption #autopin="matAutocomplete">
        @for (item of pincodeList ; track item) {
        <mat-option [value]="item" (onSelectionChange)="onSelectPin(item)">{{
          item
          }}</mat-option>
        }
      </mat-autocomplete>
    </div>
    } @if(data.type === 'centralizedPm' || data.type === 'pm'){
    <div class="d-flex flex-column input-div">
      <span class="input-text">Enter Field Level User</span>
      <input class="wishlist-input dp-input-control" type="tel" placeholder="Search by field user name"
        aria-label="Search" [formControl]="fieldWorkerName" [matAutocomplete]="autoId" (click)="fetchUsers()" />

      <mat-autocomplete autoActiveFirstOption #autoId="matAutocomplete">
        @for (item of filterUserList ; track item) {
        <mat-option [value]="item.name" (onSelectionChange)="onSelectionUser(item)" class="userNameEmail">
          <div>{{ item.name }}</div>
          <div style="color: var(--text-tertiary);">{{ item.email }}</div>
        </mat-option>
        }
      </mat-autocomplete>
    </div>
    }
  </div>

  <div class="d-flex flex-wrap item-gap">

    <div class="item-wrapper" (click)="openFavDialog(data.type)">
      <span class="item-text">My Favourites</span>
    </div>

    @for (item of wishlists; track item) { @if(data.type === 'centralizedPm' ||
    data.type === 'pm' ) { @if(pin.value){
    <div class="item-wrapper" (click)="openUserWishListDialog(item, data.type)">
      <span class="item-text">{{ item.name }}</span>
      @if(data.type === 'centralizedPm'){
      @if(item.count){
      <span class="item-text">({{ item.count }})</span>
      }

      }
      <span class="btn-gap d-flex">
        @if(canRename || user == item.userID){
        <div class="new-div" style="background: var(--edit); " (click)="onEditClick(item, $event)"></div>
        } @if(canDeleteWishlist || user == item.userID){
        <img src="../../../../assets/images/crossIconDarkTheme.svg" class="icon-img"
          (click)="onDeleteClick(item, $event)" />
        }
      </span>
    </div>
    }@else if(searchName || fieldWorkerName.value){

    <div class="item-wrapper" (click)="openUserWishListDialog(item, data.type)">
      <span class="item-text">{{ item.name }}</span>
      @if(data.type === 'centralizedPm'){
      @if(item.count){
      <span class="item-text">({{ item.count }}) - {{ item.pincode }}</span>
      }
      }
      <span class="btn-gap d-flex">
        @if(canRename || item.wishlistCreatedBy == user){
        <div class="new-div" style="background: var(--edit); " (click)="onEditClick(item, $event)"></div>
        } @if(canDeleteWishlist || item.wishlistCreatedBy == user){
        <img src="../../../../assets/images/crossIconDarkTheme.svg" class="icon-img"
          (click)="onDeleteClick(item, $event)" />
        }
      </span>
    </div>
    } } @else if(item?.status != 'P' && (data.type === 'centralizedFd' ||
    data.type === 'fd')){
    <div class="item-wrapper" (click)="openUserWishListDialog(item, data.type)">
      <span class="item-text">{{ item.name }}&nbsp;({{ item.count }})</span>
      <span class="btn-gap">
        <div class="new-div" style="background: var(--edit); " (click)="onEditClick(item, $event)"></div>
        <img src="../../../../assets/images/crossIconDarkTheme.svg" class="icon-img"
          (click)="onDeleteClick(item, $event)" />
      </span>
    </div>
    } @else if(data.type === 'centralizedReach' || data.type === 'Reach'){
    <div class="item-wrapper" (click)="openUserWishListDialog(item, data.type)">
      <span class="item-text">{{ item.name }}&nbsp;({{ item.count }})&nbsp;</span>
      <span class="btn-gap">
        <div class="new-div" style="background: var(--edit); " (click)="onEditClick(item, $event)"></div>
        <img src="../../../../assets/images/crossIconDarkTheme.svg" class="icon-img"
          (click)="onDeleteClick(item, $event)" />
      </span>
    </div>
    } @else {
    <div class="item-wrapper" (click)="openUserWishListDialog(item, data.type)">
      <span class="item-text">{{ item.name }}&nbsp;({{ item.count }})&nbsp;<span
          style="color: var(--brand-destructive)">(Pending - Transferred to {{ item.transferredToName || "-"
          }})</span></span>
    </div>
    } }
  </div>

  <!-- <mat-dialog-actions class="d-flex justify-content-center for-mobile-view-action">
  <button class="dp-primary-btn create-btn d-flex align-items-center" (click)="openAddWishlistDialog()">
      <div class="new-div" style="background: var(--add);width:16px;height:16px"></div>
      <span class="ms-1">Create new</span>
    </button>
</mat-dialog-actions> -->

  <div class="d-flex justify-content-center for-mobile-view-action">
    <button class="dp-primary-btn create-btn d-flex align-items-center" (click)="openAddWishlistDialog()">
      <div class="new-div" style="background: var(--add);width:16px;height:16px"></div>
      <span class="ms-1">Create new</span>
    </button>
  </div>
</div>
<app-loader [isLoading]="isLoading"></app-loader>